<template>
	<popup
			@updateClosePopup="onCloseDialog"
			@updateSave="onSave"
			height-head="40px"
			:title="getTitle"
			:fullscreen="false"
			:width="otherStatementsItem ? '1400' : '340'"
			:btn-text="otherStatementsItem ? 'Generate' : 'Generate'"
			:is-disabled="isDisabledStep2"
	>
		<main-table
				v-if="otherStatementsItem"
				padding="0 0 10px"
				:itemsPerPageAmount="999"
				:headers="getHeaders"
				:listItems="otherStatementsItem"
				:is-hide-header="false"
				:is-pagination="false"
				:is-last-row="false"
				:check-all="checkAll"
				:indeterminate="indeterminate"
				@updateCheckOrder="onCheckOrder"
				@updateCheckOrders="onCheckOrders"
				@updateClickButton="onClickButton"

		></main-table>

		<div v-else>

			<field
					margin="10px 0 0 0"
					width="300px"
					label="Month"
					type="text"
					placeholder="Enter month"
					@updateDate="onDate($event, 'month')"
					:dateValue="month"
					isNoTitle
					isDate
					date-picker-type="month"
					:month-mod="monthMod"
			></field>

			<field
					:class-error="$v.department && $v.department.$error"
					margin="10px 0 16px 0"
					width="300px"
					label="Department"
					placeholder="Select department"
					@updateSelect="onSelect($event, 'department')"
					:autocompleteValue="department"
					:items="managerStatementsDepartments"
					:isClearable="false"
					is-select
					is-required
			></field>

		</div>

	</popup>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import Popup from "@/shared/Popup/Popup.vue";
// validations
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// constants
import tableHeaders from "@/components/Accounting/ManagerStatements/ManagerStatementsForm/tableHeaders";
import { getFormatYmToLongTitle } from "@/helper";

export default {
	name: "MonthSalaryForm",
	mixins: [ validationMixin ],
	components: { Popup },
	props: {
		otherStatementsItem: Array,
		dispatcherStatementsItem: Array,
		// managerStatementsMonth: Array,
		managerStatementsDepartments: Array
	},
	computed: {
		...mapGetters([
			"managerStatementsItem",
		]),
		getHeaders() {
			return tableHeaders[this.department];
		},
		getTitle() {
			if (this.otherStatementsItem && this.department && this.managerStatementsDepartments) {
				return this.managerStatementsDepartments.find(item => item.id === this.department).value;
			}
			return 'Month salary';
		},
		isDisabledStep2() {
			return !!this.otherStatementsItem && !!this.isDisabled;
		}
	},
	validations() {
		return {
			department: { required },
		};
	},
	data: () => ({
		month: null,
		department: null,
		manager: null,
		managerStatementsItemList: null,
		checkAll: false,
		selected: [],
		indeterminate: false,
		type: 2,
		monthMod: null,
		isDisabled: true,
		itemButton: null,
		keyButton: null,
	}),
	methods: {
		...mapActions([
			'getManagerStatementsCreate',
			'actionPreloader',
			'onManagerStatements',
			'setAlert',
			'getStatementsDefaultCreateMonthType',
			'onSafetyStatementsSave',
			'onDispatcherStatements',
		]),

		onClickButton(args) {
			this.$emit("updateClickButton", args);
			const { key, item } = args;
			this.itemButton = item;
			this.keyButton = key;
		},
		
		async onDate(value) {
			// this[key] = value + '-01';

			this.month = value;
			this.monthMod = getFormatYmToLongTitle(value);

			const month = this.month;
			this.department = null;
			await this.getStatementsDefaultCreateMonthType( month );
		},

		onCheckOrder(orderId) {
			let idx;
			let item;

			if (this.department === 1) {
				// Safety
				idx = this.selected.findIndex(({ user_id }) => user_id === orderId);
				item = this.otherStatementsItem.find(({ user_id }) => user_id === orderId);
			} else if (this.department === 7) {
				idx = this.selected.findIndex(({ dispatcher_id }) => dispatcher_id === orderId);
				item = this.otherStatementsItem.find(({ dispatcher_id }) => dispatcher_id === orderId);
			} else {
				idx = this.selected.findIndex(({ dispatcher_id }) => dispatcher_id === orderId);
				item = this.otherStatementsItem.find(({ dispatcher_id }) => dispatcher_id === orderId);
			}

			if (idx === -1) {
				this.selected.push(item);
			} else {
				this.selected.splice(idx, 1);
			}

			if (!this.selected.length) {
				this.indeterminate = false;
				this.checkAll = false;
				this.isDisabled = true;
			}
			if (this.selected.length && this.selected.length !== this.otherStatementsItem.length) {
				this.indeterminate = true;
				this.isDisabled = false;
			}

			if (this.selected.length === this.otherStatementsItem.length) {
				this.indeterminate = false;
				this.checkAll = true;
				this.isDisabled = false;
			}
		},
		onCheckOrders(value) {
			if (value) {
				this.selected = this.otherStatementsItem.map((body) => body);
				this.isDisabled = false;
			} else {
				this.selected = [];
				this.indeterminate = false;
				this.isDisabled = true;
			}

			this.checkAll = value;
			this.otherStatementsItem.forEach((item) => (item.isCheck = value));
		},

		async onSave() {
			this.$v.$touch();
			if (this.$v.$error) {
				this.setAlert({ type: "error", message: "Failed to save the manager statement. Please check the data and try again ⚠️" });
				return;
			}

			this.actionPreloader(true);

			try {
				if (this.otherStatementsItem) {

					if (this.department === 1) {
						// Safety
						this.$emit('updateMonthSafety', { rows: this.selected, date: this.month });
						// this.onSafetyStatementsSave({ rows: this.selected, date: this.month });

					} else if (this.department === 7) {
						const dispId = this.selected.map(item => item.dispatcher_id);

						this.$emit('updateMonthDispatcher', { dispatchers: dispId, date: this.month });

					} else {
						const data = this.department === 0 ? this.selected : this.otherStatementsItem;
						const { status } = await this.onManagerStatements(data);
						this.setAlert({
							type: status ? "success" : "error",
							message: status
								? "Manager statement saved successfully 🎉"
								: "Failed to save manager statement. Please try again ⚠️"
						});
					}

					this.onCloseDialog(1);

				} else {
					const { month, department, type } = this.$data;

					const values = { month, department, type };

					await this.getManagerStatementsCreate(values);

					this.$emit('updateMonthMod', month);
				}
			} catch (error) {
				this.setAlert({ type: "error", message: "❌Unexpected error occurred" });
				console.error("❌Manager statement error:", error);
			} finally {
				this.actionPreloader(false);
			}
		},
		onCloseDialog(value) {
			console.log('%c [  onCloseDialog value ] ', 'color:#bada55', typeof value, value );
			this.$emit('updateCloseDialog', value);
		},
		async onSelect({ value }, key) {
			this[key] = value.id;
			this.manager = value?.manager;
		},
	},
	beforeMount() {
		if (this.otherStatementsItem) this.department = +this.otherStatementsItem[0].department;

		const date = new Date();
		this.month = `${ date.getFullYear() }-${ String(date.getMonth() + 1).padStart(2, '0') }-01`;
		this.monthMod = getFormatYmToLongTitle(this.month);

		if (this.managerStatementsItem) this.managerStatementsItemList = this.managerStatementsItem;
	},
	watch: {
		otherStatementsItem(value, oldValue) {
			if (value !== oldValue) {
				this.otherStatementsItem = value;
			}
		},
	},
};
</script>

<style scoped lang="scss">

</style>
